import { requireEnvironmentVariable } from "./environment";

const skipShopify = process.env.GATSBY_SKIP_SHOPIFY === "true";

export const shopifyStoreDomain = skipShopify
  ? "disabled.myshopify.com"
  : requireEnvironmentVariable(
      "GATSBY_SHOPIFY_STORE_DOMAIN",
      process.env.GATSBY_SHOPIFY_STORE_DOMAIN
    );

export const shopifyStorefrontAccessToken = skipShopify
  ? "shopify-disabled"
  : requireEnvironmentVariable(
      "GATSBY_SHOPIFY_STOREFRONT_ACCESS_TOKEN",
      process.env.GATSBY_SHOPIFY_STOREFRONT_ACCESS_TOKEN
    );
